import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { auctionsParamsSchema } from 'src/pages/transport/auctions/tiles/schema';

export function useAuctionsPageParams() {
  return usePageParamsFromSchema(auctionsParamsSchema, {
    filters: {
      favouritesOnly: { label: 'Favourites Only' },
      quickFilterId: { label: 'Quick Filter' },
    },
  });
}

export type AuctionsPageParams = ReturnType<typeof useAuctionsPageParams>;
